<template>
    <div class="about">
        <AddressBookVue/>
    </div>
</template>

<script>
    import AddressBookVue from '@/components/AddressBook.vue';
	
    export default {
		name: 'addressBookView',
        components: {AddressBookVue},
        data () {
            return {}
        },
	}
</script>